<template>
<!--  临床应用-->
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="imgBoxUrl" class="el-image__inner">
      </div>
    </div>
    <!--    导航-->
    <div class="num_all">
      <el-row >
        <el-col :span="18" :justify="end" ><div class="grid-content num_r">
          <el-menu :default-active="numIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item  v-for="item in numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
          </el-menu>
        </div></el-col>
      </el-row>
    </div>

    <div class="contentBox" v-show="showData.box1">
      <div class="cu_all">
        <div class="cli_d_1">{{ item.text1 }}</div>
        <div class="cli_img">
          <el-image
            style="width: 1176px; height: 700px"
            :src="item.imageUrl"
            :fit="contain" v-show="showData.img1"></el-image>
          <video :src="videoUrl" v-show="showData.video1"></video>
        </div>
        <div class="cli_d_2" v-if="item.text2 != ''" >{{item.text2}}</div>
      </div>

    </div>
    <div class="contentBox" v-show="showData.box2">
      <div class="cu_all">
        <div class="cli_d_1">{{ item2.text1 }}</div>
        <div class="cli_img">
          <el-image
            style="width: 1176px; height: 700px"
            :src="item2.imageUrl"
            :fit="contain" v-show="showData.img2"></el-image>
          <video v-show="showData.video2" width="1176" height="700" controls>
            <source :src="videoUrl2" type="video/mp4">
          </video>
        </div>
        <div class="cli_d_2" v-if="item2.text2 != ''" >{{item2.text2}}</div>
      </div>

    </div>

  </div>
</template>

<script>
import Mun2 from "./image/mun2";
export default {
  name: "clinical",
  components: {Mun2},
  data() {
    return {
      videoUrl:"",
      videoUrl2:"http://116.62.38.250//image/nr/jjfa/11.mp4",
      numList : [
        {
          num : "1",
          tital : "牙周病治疗",
          path: "yz"
        },
        {
          num : "2",
          tital : "儿童牙病治疗",
          path: "er"
        },
      ],
      imgBoxUrl:"http://116.62.38.250//image//nr/tp/lcyy.jpg",
      urlData:"",
      showData:{
        box1: false,
        box2: false,
        img1: false,
        video1: false,
        img2: false,
        video2: false
      },
      numIndex: "1",
      item:{
        text1:"牙周病治疗",
        imageUrl:"http://116.62.38.250//image/nr/lcyy/item.jpg",
        text2:"牙周病是一种由菌斑微生物引起的慢性传染性疾病，主要分为仅影响牙龈组织的牙龈病和涉及深层牙周组织（如牙周膜、牙槽骨、牙骨质）的牙周炎两大类。随着激光技术的不断进步，激光及其辅助治疗为牙周病的非手术治疗开辟了新的领域。在众多激光波长中，铒激光凭借其优越的安全性和疗效，已广泛应用于牙周病治疗的各个环节。\n" +
          "Er:YAG激光属于中红外线激光，波长为2.94μm，与水（2.95μm）和羟磷灰石中的OH-（2.8μm）的红外线吸收峰值非常接近，使其在含水环境中成为所有波长激光中最易被吸收的一种。因此，Er:YAG激光不仅能够安全、有效地切割牙体硬组织，还可精确处理软组织，且不会对邻近组织产生热损伤。此外，它还具有杀菌、消毒、无痛、出血少等优点。\n" +
          "相比传统治疗方法，Er:YAG激光在治疗过程中显著降低了患者的不适感和疼痛感，同时极大减少了震动感，从而有效缓解了患者在口腔治疗中的痛苦和恐惧。这使得激光技术在现代口腔治疗中成为一种更加舒适且高效的选择。\n" +
          "\n" +
          "小贴士：\n" +
          "牙周病的病因\n" +
          "1、菌斑与牙石：牙周病的主要病因是牙菌斑的形成。菌斑是一种由细菌、食物残渣和唾液共同形成的生物膜，附着在牙齿表面。如果不及时清除，菌斑会矿化形成牙石，进一步引发牙龈炎和牙周炎。牙石的存在不仅容易滋生更多细菌，还会导致牙龈炎症，进而破坏牙周组织。\n" +
          "2、不良口腔卫生习惯：不规律或不正确的刷牙和口腔护理习惯会导致牙菌斑堆积，增加牙周病的风险。如果不使用牙线或牙间刷清洁牙缝，菌斑容易在牙缝中积聚，导致牙周组织受到影响。\n" +
          "3、吸烟：吸烟是牙周病的重要诱因之一。烟草中的化学物质会抑制口腔的免疫反应，降低牙龈组织的自我修复能力，增加牙周病的发生风险。此外，吸烟者的牙周组织血液循环较差，影响了牙周病的早期发现和治疗。\n" +
          "4、全身性疾病：一些全身性疾病，如糖尿病，会加重牙周病的发生和发展。糖尿病患者的免疫力较低，口腔中的细菌更容易导致牙周组织感染。同时，牙周病的存在也可能影响糖尿病的控制。\n" +
          "5、遗传因素：部分人群可能因为遗传原因，对牙周病的易感性较高。这些人即使保持良好的口腔卫生，仍然可能比常人更容易患上牙周病。\n" +
          "6、咬合创伤：不良咬合、牙齿排列不齐或咬合力不平衡可能导致局部牙齿承受过大的压力，进而引发牙周组织的损伤，加速牙周病的发生。\n" +
          "牙周病的预防\n" +
          "1、保持良好的口腔卫生：\n" +
          "（1）正确刷牙：每天早晚刷牙，使用含氟牙膏，采用正确的刷牙方法（如巴氏刷牙法），清洁牙龈边缘和牙缝区域，防止菌斑堆积。\n" +
          "（2）使用牙线或牙间刷：除了刷牙，使用牙线或牙间刷清洁牙齿之间的缝隙，防止食物残渣和菌斑在这些部位积聚。\n" +
          "2、定期口腔检查和洁牙：\n" +
          "（1）每半年到一年进行一次口腔检查，及早发现和治疗牙龈炎、牙周炎等问题。（2）定期进行专业洁牙（洗牙），去除牙菌斑和牙石，防止牙周病的发生和发展。\n" +
          "3、戒烟：\n" +
          "（1）吸烟是牙周病的高危因素之一，戒烟不仅有助于口腔健康，也有利于全身健康。\n" +
          "4、保持健康的饮食习惯：\n" +
          "（1）维持营养均衡的饮食，尤其是摄入足够的维生素C、钙和蛋白质，有助于维持牙周组织的健康。\n" +
          "（2）限制糖分摄入，减少细菌滋生的机会，防止牙菌斑的形成。\n" +
          "5、控制全身性疾病：\n" +
          "（1）尤其是糖尿病患者，需严格控制血糖水平，定期检查牙周健康情况，防止牙周病的加重。\n" +
          "6、避免不良咬合与牙齿损伤：\n" +
          "（1）及时矫正牙齿排列不齐等问题，避免咬合不正引起的牙周损伤。\n" +
          "（2）防止牙齿受外伤，避免对牙周组织造成额外损害。\n" +
          "通过保持良好的口腔卫生习惯、定期进行口腔检查和洁牙，以及避免不良生活习惯等，可以有效预防牙周病的发生和发展。"
      },
      item2:{
        text1:"儿童牙病治疗",
        imageUrl:"http://116.62.38.250//image/nr/lcyy/item.jpg",
        text2:"铒激光在儿童口腔硬组织疾病治疗中的应用非常广泛。传统的去龋方式通常依赖于机械手段，而这种治疗过程中的噪音常常让儿童感到恐惧，进而难以配合。相比之下，铒激光在去龋治疗方面具有显著的优势：\n" +
          "1.安全性高：铒激光不会产生多余的热量，因此不会对牙髓组织造成伤害。\n" +
          "2.优先去除龋坏组织：铒激光可以选择性地作用于水分含量较高的龋坏组织，确保治疗更为精准。\n" +
          "3.控制性强：铒激光的穿透深度仅约5微米，能有效地控制切割范围，避免损伤健康组织。\n" +
          "4.舒适度佳：相比传统去龋方式，激光治疗过程中的不适感更少，许多患者认为其是更为舒适的治疗选择。\n" +
          "铒激光（Er:YAG）与Er,Cr:YSGG激光均能够减少牙齿表面的微渗漏，这可能是因为激光作用后，牙本质小管的开放以及玷污层的减少。铒激光采用“微爆破”原理去除龋坏组织，当激光能量被牙体中的水分吸收时，水分迅速蒸发，导致组织内部压力瞬间升高，进而去除表层硬组织。由于牙体中水分含量不同，铒激光的切削效率也会有所差异。例如，牙本质中的水分含量高于釉质，铒激光在去除牙本质时速度更快；同样，龋坏组织中的水分含量高于正常组织，因此铒激光在去除龋坏组织时比正常硬组织更快，而乳牙的磨削速度也快于恒牙。\n" +
          "研究发现，铒激光去除乳牙龋坏的速度约为恒牙的1.5倍，因此对于儿童患者，特别是那些配合度不高的儿童，激光治疗是一种有效的手段。"
      }
    }
  },
  mounted() {
    let that = this;
    console.log("init");
    that.init();
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);
      if(that.videoUrl == ""){
        that.showData.img1 = true;
      } else {
        that.showData.video1 = true;
      }

      if(that.videoUrl2 == ""){
        that.showData.img2 = true;
      } else {
        that.showData.video2 = true;
      }
      if(that.urlData == "" || that.urlData == undefined){
        that.handleSelect("1",'ey')
      } else {
        let index = "1";
        if(that.urlData == 'er'){
          index = "1";
        } else  {
          index = that.urlData;
        }

        that.handleSelect(index,that.urlData)
      }

    },

    handleSelect(index, path) {
      let that = this;
      that.numIndex = index;
      console.log(index+path)  //获取tab标签的选中值
      console.log(index, path);
      //初始化
      that.showData.box1 = false;


      if(index == '1'){
        that.showData.box2 = false;
        that.showData.box1 = true;
      } else if(index == '2'){
        that.showData.box2 = true;
        that.showData.box1 = false;
      }
    }
  }
}
</script>

<style scoped>
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}
.cli_img{
  margin-top: 35px;
  margin-bottom: 25px;
}
.cli_d_2{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0.39px;
  text-align: justify;
  line-height: 32px;
  white-space: pre-wrap;
}
.cli_d_1{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
}
.cu_all{
  width: 1176px;
}
.contentBox {
  width: 1176px;
  margin: 50px auto;
  display: flex;
  justify-content: center;
}
.productPage {
  display: block;
  width: 1920px;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  height: 600px;
}

.imageItem {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/clinical.vue